import { render, staticRenderFns } from "./GiftBoxLimitedFaqs.vue?vue&type=template&id=631d4f93&scoped=true&"
import script from "./GiftBoxLimitedFaqs.vue?vue&type=script&lang=js&"
export * from "./GiftBoxLimitedFaqs.vue?vue&type=script&lang=js&"
import style0 from "./GiftBoxLimitedFaqs.vue?vue&type=style&index=0&id=631d4f93&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631d4f93",
  null
  
)

export default component.exports